export const convertFeatureCollectionToGeozoneArray = (data) => {
    if (data.features.length === 0)
        return null;
    return data.features.map((feature) => {
        return feature;
    });
};
export const findGeozonesFromFeatures = (features, geozones) => {
    //Проверяем, что к нам пришли непустые массивы
    if (features.length === 0 || geozones.length === 0)
        return null;
    const found_geozones = [];
    features.forEach((feature) => {
        geozones.forEach((geozone) => {
            //Ищем по id
            if (feature.id === geozone._id) {
                const { id, ...feature_new } = feature;
                found_geozones.push({
                    geojson: feature_new,
                    _id: id,
                    user_id: geozone.user_id,
                });
                return;
            }
        });
    });
    if (found_geozones.length === 0)
        return null;
    return found_geozones;
};
